module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-right-up-528ca3f8e067336e21ddd322ac7dff9e.svg";